'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var core = require('@pixi/core');
var alpha = require('./alpha.js');

class AlphaFilter extends core.Filter {
  constructor(alpha$1 = 1) {
    super(core.defaultVertex, alpha["default"], { uAlpha: 1 });
    this.alpha = alpha$1;
  }
  get alpha() {
    return this.uniforms.uAlpha;
  }
  set alpha(value) {
    this.uniforms.uAlpha = value;
  }
}

exports.AlphaFilter = AlphaFilter;
//# sourceMappingURL=AlphaFilter.js.map
